import { generateQueryString } from '../../../common/base/report/report-util';

const buildFlatParams = (criteria, criteriaStats) => ({
  format: criteria.format,
  fromDate: criteria.fromDate,
  toDate: criteria.toDate,
  asOfDate: criteria.asOfDate,
  issueDate: criteria.issueDate,
  fromTaxYear: criteria.fromTaxYear,
  toTaxYear: criteria.toTaxYear,
  currentTaxYear: criteria.currentTaxYear,
  includeUnchanged: criteria.includeUnchanged,
  includeNewParcels: criteria.includeNewParcels,
  taxDistrictCodes: (criteria.taxDistricts || []).join(','),
  workstation: (criteria.wkst || []).join(','),
  reasonCodes: (criteria.reasonCodes || []).join(','),
  taxYears: (criteria.taxYears || []).join(','),
  taxTypes: (criteria.taxType || []).join(','),
  printDetails: criteria.printDetails,
  syncWithTaxrollSummary: criteria.syncWithTaxrollSummary,
  printFullDesc: criteria.printFullDesc,
  pageBreakdown: criteria.pageBreakdown,
  titleToPrint: criteria.titleToPrint,
  reportPrintPattern: criteria.reportPrintPattern,
  unresolved: criteria.showUnresolved,
  assigned: (criteria.assignedTo || []).join(','),
  adjustmentCodes: (criteria.adjTypes || []).join(','),
  fullDetails: criteria.showFullDetails,
  allSATaxdistrict: criteria.allSATaxdistrict,
  excludeSATaxdistrict: criteria.excludeSATaxdistrict,
  excludeSpecialAssessmentDistricts: criteria.excludeSpecialAssessmentDistricts,
  onlySpecialAssessmentDistricts: criteria.onlySpecialAssessmentDistricts,
  allWkst: criteriaStats.allWkst,
  allTaxDistricts: criteriaStats.allTaxDistricts,
  allTaxTypes: criteriaStats.allTaxTypes,
  allReasonCodes: criteriaStats.allReasonCodes,
  isActive: criteria.isActive,
  expiredOnly: criteria.expiredOnly,
  fromWarrantNumber: criteria.fromWarrantNumber,
  toWarrantNumber: criteria.toWarrantNumber,
  notPrinted: criteria.notPrinted,
});

export const queryStringCalc = ({
  reportConfig,
  params: paramsArg,
  criteria,
  criteriaStats = {},
  token,
  devSetting,
}) => {
  const p = paramsArg || buildFlatParams(criteria, criteriaStats);
  const qp = [];

  if (reportConfig) {
    if (reportConfig.filters.showAsOfDate && p.asOfDate) {
      qp.push(`asOfDate=${p.asOfDate}`);
    }
    if (reportConfig.filters.showTaxYears && p.fromTaxYear) {
      qp.push(`fromTaxYear=${p.fromTaxYear}`);
    }
    if (reportConfig.filters.showTaxYears && p.toTaxYear) {
      qp.push(`toTaxYear=${p.toTaxYear}`);
    }
    if (reportConfig.filters.showTaxDistricts && p.taxDistrictCodes) {
      qp.push(`taxDistrictCodes=${encodeURIComponent(p.taxDistrictCodes)}`);
    }
    if (reportConfig.filters.showWorkstation) {
      qp.push(`workstation=${p.workstation}`);
    }
    if (reportConfig.filters.showReasonCode && p.reasonCodes) {
      qp.push(`reasonCodes=${p.reasonCodes}`);
    }
    if (reportConfig.filters.showTaxYearList && p.taxYears) {
      qp.push(`taxYears=${p.taxYears}`);
    }
    if (reportConfig.filters.showPrintDetails) {
      qp.push(`printDetails=${p.printDetails}`);
    }
    if (reportConfig.filters.syncWithTaxrollSummary) {
      qp.push(`syncWithTaxrollSummary=${p.syncWithTaxrollSummary}`);
    }
    if (reportConfig.filters.showPrintFullDesc) {
      qp.push(`printFullDesc=${p.printFullDesc}`);
    }
    if (reportConfig.filters.showPageBreakdownYears) {
      qp.push(`pageBreakdown=${p.pageBreakdown}`);
    }
    if (reportConfig.filters.showTitle) {
      qp.push(`titleToPrint=${p.titleToPrint}`);
    }
    if (reportConfig.filters.showTypeOfCollectionSummary) {
      qp.push(`reportPrintPattern=${p.reportPrintPattern}`);
    }
    if (reportConfig.filters.showUnresolved) {
      qp.push(`unresolved=${p.unresolved}`);
    }
    if (reportConfig.filters.showAssignedUser && p.assigned) {
      qp.push(`assigned=${p.assigned}`);
    }
    if (reportConfig.filters.showTaxTypes && p.taxTypes) {
      qp.push(`taxTypes=${p.taxTypes}`);
    }
    // for adjustments reports
    if (reportConfig.filters.showAdjustCode && p.adjustmentCodes) {
      qp.push(`adjustmentCodes=${p.adjustmentCodes}`);
    }
    if (reportConfig.filters.showTaxType && p.taxTypes) {
      qp.push(`taxType=${p.taxTypes}`);
    }
    // Personal Tax Warrants: reprint a run by the numbers it issued, and find the
    // documents a run never got as far as printing.
    if (reportConfig.filters.showWarrantNumberRange && p.fromWarrantNumber) {
      qp.push(`fromWarrantNumber=${p.fromWarrantNumber}`);
    }
    if (reportConfig.filters.showWarrantNumberRange && p.toWarrantNumber) {
      qp.push(`toWarrantNumber=${p.toWarrantNumber}`);
    }
    if (reportConfig.filters.showNotPrinted && p.notPrinted) {
      qp.push(`notPrinted=${p.notPrinted}`);
    }
    if (reportConfig.filters.showTaxYears && p.taxYears) {
      qp.push(`taxYear=${p.taxYears}`);
    }
    if (reportConfig.filters.showFullDetails && p.fullDetails) {
      qp.push(`fullDetails=${p.fullDetails}`);
    }
    if (reportConfig.filters.showSATaxDistrict && p.allSATaxdistrict) {
      qp.push(`allSATaxdistrict=${p.allSATaxdistrict}`);
    }
    if (reportConfig.filters.showExcludeSATaxDistrict && p.excludeSATaxdistrict) {
      qp.push(`excludeSATaxdistrict=${p.excludeSATaxdistrict}`);
    }
    if (reportConfig.filters.showExcludeSpecialAssessmentDistricts && p.excludeSpecialAssessmentDistricts) {
      qp.push(`excludeSpecialAssessmentDistricts=${p.excludeSpecialAssessmentDistricts}`);
    }
    if (reportConfig.filters.showOnlySpecialAssessmentDistricts && p.onlySpecialAssessmentDistricts) {
      qp.push(`onlySpecialAssessmentDistricts=${p.onlySpecialAssessmentDistricts}`);
    }
    if (reportConfig.filters.showFileFormat && p.format && p.format !== 'pdf') {
      qp.push(`format=${p.format}`);
    }
    if (reportConfig.filters.showDates) {
      if (p.fromDate) qp.push(`fromDate=${p.fromDate}`);
      if (p.toDate) qp.push(`toDate=${p.toDate}`);
    }
    if (reportConfig.filters.showIssueDate && p.issueDate) {
      qp.push(`issueDate=${p.issueDate}`);
    }
    if (reportConfig.filters.showActiveOnly && p.isActive) {
      qp.push('isActive=true');
    }
    if (reportConfig.filters.showExpiredOnly && p.expiredOnly) {
      qp.push('expiredOnly=true');
    }
    if (reportConfig.filters.showCurrentTaxYear && p.currentTaxYear) {
      qp.push(`currentTaxYear=${p.currentTaxYear}`);
    }
    if (reportConfig.filters.showIncludeUnchanged) {
      qp.push(`includeUnchanged=${p.includeUnchanged}`);
    }
    if (reportConfig.filters.showIncludeNewParcels) {
      qp.push(`includeNewParcels=${p.includeNewParcels}`);
    }
  } else {
    if (p.fromDate) qp.push(`fromDate=${p.fromDate}`);
    if (p.toDate) qp.push(`toDate=${p.toDate}`);
  }

  if (token) {
    qp.push(`token=${token}`);
  }

  qp.push(`allWkst=${p.allWkst}`);
  qp.push(`allTaxDistricts=${p.allTaxDistricts}`);
  qp.push(`allTaxTypes=${p.allTaxTypes}`);
  qp.push(`hideTheTaxDueWhichAreZero=${true}`);
  qp.push(`allReasonCodes=${p.allReasonCodes}`);

  if (devSetting && devSetting.isTestEnvironment) {
    qp.push('isTestCafe=1');
  }

  return generateQueryString(qp);
};

export const reportList = () => {
  const list = [
    {
      description: 'Overpayment Summary',
      config: {
        route: 'taxInquiry/overpayment-summary',
        filters: {
          showTaxYears: true,
          showDates: true,
          showTaxDistricts: true,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: true,
          syncWithTaxrollSummary: true,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: true,
        },
      },
    },
    {
      description: 'Taxroll Summary',
      config: {
        route: 'taxInquiry/taxroll-summary',
        filters: {
          showTaxYears: true,
          showTaxDistricts: true,
          showTitle: true,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: true,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
          showExcludeSpecialAssessmentDistricts: true,
          showOnlySpecialAssessmentDistricts: true,
        },
      },
    },
    {
      description: 'Summary by Date/Type',
      config: {
        route: 'taxInquiry/summary-by-date-type',
        filters: {
          showTaxYears: true,
          showTaxDistricts: false,
          showTitle: true,
          showPageBreakdownYears: false,
          showAsOfDate: true,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: true,
        },
      },
    },
    {
      description: 'Special Assessments Summary',
      config: {
        route: 'taxInquiry/special-assessments-summary',
        filters: {
          showTaxYears: true,
          showTaxDistricts: false,
          showTitle: true,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
        },
      },
    },
    {
      description: 'Print Protest Tax',
      config: {
        route: 'taxInquiry/protest-tax',
        filters: {
          showTaxYears: false,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: true,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showTaxYearList: true,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
        },
      },
    },
    {
      description: 'Tax Roll Audit',
      config: {
        route: 'taxInquiry/taxroll-audit',
        filters: {
          showTaxYears: true,
          showTaxDistricts: true,
          showTitle: true,
          showPageBreakdownYears: true,
          showAsOfDate: false,
          showPrintDetails: true,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: true,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,

        },
      },
    },
    {
      description: 'Abstract',
      config: {
        route: 'taxInquiry/abstract',
        filters: {
          showTaxYears: true,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,

        },
      },
    },
    {
      description: 'Mailing Address Changes',
      config: {
        route: 'taxInquiry/mailing-address-changes-summary',
        filters: {
          showTaxYears: true,
          showWorkstation: true,
          showDates: true,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
          showReasonCode: true,
          defaultExcludeReasonCodes: [6],

        },
      },
    },
    {
      description: 'Attempt to Locate Report',
      config: {
        route: 'taxInquiry/attempt-to-locate-summary',
        filters: {
          showTaxYears: true,
          showWorkstation: true,
          showDates: true,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
          showReasonCode: false,

        },
      },
    },
    {
      description: 'Tax Roll Changes Report',
      config: {
        route: 'taxInquiry/taxroll-changes-summary',
        filters: {
          showTaxYears: true,
          showDates: true,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
          showReasonCode: true,

        },
      },
    },
    {
      description: 'Taxes on Homestead Exempt Property',
      config: {
        route: 'taxInquiry/tax-homestead-exempt-summary',
        filters: {
          showTaxYears: true,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
        },
      },
    },
    {
      description: 'Legal Description Changes',
      config: {
        route: 'taxInquiry/legal-description-changes',
        filters: {
          showCurrentTaxYear: true,
          showIncludeUnchanged: true,
          showIncludeNewParcels: true,
          showTaxYears: false,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
        },
      },
    },
    {
      description: 'County Owned Property List',
      config: {
        route: 'taxInquiry/county-owned-property-list',
        filters: {
          showTaxYears: false,
          showTaxDistricts: false,
          showTitle: false,
          showPageBreakdownYears: false,
          showAsOfDate: false,
          showPrintDetails: false,
          syncWithTaxrollSummary: false,
          showPrintFullDesc: false,
          showTypeOfCollectionSummary: false,
          showUnresolved: false,
          showAssignedUser: false,
          showTaxTypes: false,
        },
      },
    },
  ];
  return list;
};

export const adjustMentReportList = () => {
  const item = [{
    id: 1,
    description: 'Adjustment by Type',
    config: {
      route: 'tax/adjustment-report/byType',
      filters: {
        showDates: true,
        showTaxYears: true,
        showTaxDistricts: true,
        showFromDate: true,
        showToDate: true,
        showAdjustCode: true,
        showTaxType: false,
        showFullDetails: false,
        showSATaxDistrict: false,
      },
    },
  },
  {
    id: 2,
    description: 'Adjustment by Date',
    config: {
      route: 'tax/adjustment-report/byDate',
      filters: {
        showDates: true,
        showTaxYears: true,
        showTaxDistricts: true,
        showFromDate: true,
        showToDate: true,
        showAdjustCode: false,
        showTaxType: true,
        showFullDetails: false,
        showSATaxDistrict: false,
        showFileFormat: true,
      },
    },
  },
  {
    id: 3,
    description: 'Adjustment List by Year/Tax District',
    config: {
      route: 'tax/adjustment-report/yearSD',
      filters: {
        showDates: true,
        showTaxYears: true,
        showTaxDistricts: true,
        showFromDate: false,
        showToDate: false,
        showAdjustCode: false,
        showTaxType: true,
        showFullDetails: true,
        showSATaxDistrict: true,
        showExcludeSATaxDistrict: true,
      },
    },
  },
  {
    id: 4,
    description: 'Tax Records with Balance after Adjustments',
    config: {
      route: 'tax/adjustment-report/afterAdjustment',
      filters: {
        showDates: true,
        showTaxYears: false,
        showTaxDistricts: true,
        showFromDate: false,
        showToDate: false,
        showAdjustCode: true,
        showTaxType: false,
        showFullDetails: false,
        showSATaxDistrict: false,
      },
    },
  },
  {
    id: 5,
    description: 'Clerical Error Report',
    config: {
      route: 'tax/adjustment-report/clericalError',
      defaultAdjCodes: ['C/E', 'C/CE', 'CE'],
      filters: {
        showDates: true,
        showTaxYears: true,
        showTaxDistricts: true,
        showAdjustCode: true,
        showTaxType: false,
        showFullDetails: false,
        showSATaxDistrict: false,
      },
    },
  }];
  return item;
};

export const delenquentReportList = () => {
  const item = [{
    id: 1,
    description: 'Personal Tax Warrant Summary',
    config: {
      route: 'tax/personal-taxwarrant-summary-report',
      filters: {
        showDates: true,
        showActiveOnly: true,
        showExpiredOnly: true,
        showIssueDate: false,
        showTaxYears: false,
        showTaxDistricts: true,
        showFromDate: false,
        showToDate: false,
        showAdjustCode: false,
        showTaxType: true,
        showFullDetails: false,
        showWarrantNumberRange: true,
        showNotPrinted: true,
      },
    },
  },
  {
    id: 2,
    description: 'Personal Tax Warrants',
    config: {
      route: 'tax/personal-taxwarrant-report',
      filters: {
        showDates: false,
        showIssueDate: true,
        showTaxYears: false,
        showTaxDistricts: true,
        showFromDate: false,
        showToDate: false,
        showAdjustCode: false,
        showTaxType: true,
        showFullDetails: true,
        showWarrantNumberRange: true,
        showNotPrinted: true,
      },
    },
  },
  {
    id: 3,
    description: 'Tax Warrant Letters',
    config: {
      route: 'tax/personal-taxwarrant-letter-report',
      filters: {
        showDates: true,
        showIssueDate: false,
        showTaxYears: false,
        showTaxDistricts: true,
        showFromDate: false,
        showToDate: false,
        showAdjustCode: true,
        showTaxType: true,
        showFullDetails: false,
        showWarrantNumberRange: true,
        showNotPrinted: true,
      },
    },
  }];
  return item;
};

export default {
  reportList,
  queryStringCalc,
};
